export default __webpack_public_path__ + "static/media/TessoMap.dcdd1c0e.jpg";